<template>
    <div class="alternate-form-component-container">
        <div class="alternate-form-component-container__icon-container">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V6C22.5 5.60218 22.342 5.22064 22.0607 4.93934C21.7794 4.65804 21.3978 4.5 21 4.5ZM19.35 6L12 11.085L4.65 6H19.35ZM3 18V6.6825L11.5725 12.615C11.698 12.7021 11.8472 12.7488 12 12.7488C12.1528 12.7488 12.302 12.7021 12.4275 12.615L21 6.6825V18H3Z"
                    fill="#1B3C70"
                />
            </svg>
        </div>
        <div class="alternate-form-component-container__input-group">
            <ValidationProvider
                v-slot="{ errors }"
                rules="email-required|email|email-max:50"
                tag="article"
                name="e-mail adres"
            >
                <AlternateFormComponent
                    v-model="email"
                    name="email"
                    :label="label"
                    :placeholder="label"
                    :required="isRequired"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                >
                </AlternateFormComponent>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
import AlternateFormComponent from './AlternateFormComponent.vue';
import { ValidationProvider, extend } from 'vee-validate';
import { required, email, max } from 'vee-validate/dist/rules';

extend('email-required', {
    ...required,
    message: 'E-mailadres is een verplicht veld',
});

extend('email', {
    ...email,
    message: 'Voer het email adres correct in',
});

extend('email-max', {
    ...max,
    message: 'Voer het email adres correct in',
});

export default {
    name: 'AlternateFormEmail',
    components: { ValidationProvider, AlternateFormComponent },
    props: {
        value: String,
        label: {
            type: String,
            default: 'E-mail',
        },
        isRequired: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            email: this.value ?? '',
        };
    },
    watch: {
        email: {
            handler(newVal) {
                if (newVal) {
                    this.$emit('input', newVal);
                }
            },
        },
    },
};
</script>
